export const START_FETCH = 'MENUS_START_FETCH'
export const FETCHED = 'MENUS_FETCHED'
